import React, { useState, useEffect } from 'react'
import Title from './Title';
import { Table, TableHead, TableRow, TableCell, TableBody, Button, Grid } from '@material-ui/core';
import {history, MyMess} from '../../App'
import { useSelector } from 'react-redux';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import { GetMerchants } from '../../server/WebServiceUrl';
import Axios from 'axios';
import {parsePhone, formatPhoneNumber} from "../../utils/Utils";

// function createKopaProData(id, code, desc,plan, expiryDate){
//   return {id, code, desc,plan,expiryDate};
// }

// const license = [
//   createKopaProData('0', 'flossygarden', 'Flossy Garden','et', '2021-12-31'),
//   createKopaProData('1', 'wffc', 'Wing Fung','pm', '2021-12-31'),
//   createKopaProData('2', 'jckopapro', 'Joseph Debug','su', '2021-11-27')
// ]

const getPlan = (planCode) => {
  switch(planCode){
  case 'su':
    return MyMess.kopaproLicense.plan.su
  case 'pm':
    return MyMess.kopaproLicense.plan.pm
  case 'et':
     return MyMess.kopaproLicense.plan.et    
  default:
    return 'N/A'
  }
  
}

export default function MerchantList() {  
  // const debug = (e) => {
  //   GlobalSnackBarUtil.open({
  //     message: 'hahaha',
  //     severity:'error',
  //     onCloseHandler: () => {
  //       GlobalSnackBarUtil.close();
  //     }
  //   })
  // }
  const user = useSelector(state => state.user);
  const [license,setLicense] = useState([]);

  useEffect(()=> {

    if(user.authorization){
      runRefresh()
    }

    return ;
  },[])

  const changeButtonHandler = (e,licenseId) => {
    history.push('/main/merchant/edit/' + licenseId);
  }

  const historyButtonHandler = (e,licenseId) => {
    
  }

  const refreshHandler = (e) => {
    if(user.authorization){
      runRefresh()
    }
  }

  const runRefresh =async () => {
    let res = await Axios.get(GetMerchants);    
    if(res && res.status === 200 && res.data && res.data.pass){
      let myData = [];
      myData = res.data.merchants;
      let merchants = [];
      myData.map((value,index)=>{
        let mc = {
          progCode:value.progCode ,
          name: value.firstName + ' ' + value.lastName,
          tel: formatPhoneNumber(parsePhone(value.countryCode, value.areaCode, value.tel)),
          compTel: formatPhoneNumber(parsePhone(value.compCountryCode, value.compAreaCode, value.compTel)),
          email: value.email
        }
        merchants.push(mc);
      })
      setLicense(merchants);
    }else{
      GlobalSnackBarUtil.open({
        message:MyMess.refreshFail,
        severity:'error'
      })
    }
  }

  return (
    <React.Fragment>
      <Grid container={true} justify="space-between">
        <Grid item xs={6}>
          <Title>{MyMess.merchant.merchant}</Title>
        </Grid>  
        <Grid container justify="flex-end">

          <Button variant="outlined" onClick={refreshHandler}>
              {MyMess.refresh}
          </Button>
          <Button variant="outlined" onClick={e => {history.push('/main/merchant/create')}}>
              {MyMess.addNewMerchant}
          </Button>
        </Grid>
      </Grid>      
      

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{MyMess.merchant.progCode}</TableCell>
            <TableCell>{MyMess.merchant.name}</TableCell>
            <TableCell>{MyMess.merchant.tel}</TableCell>
            <TableCell>{MyMess.merchant.compTel}</TableCell>
            <TableCell>{MyMess.merchant.email}</TableCell>            
            <TableCell align="right"></TableCell>            
          </TableRow>
        </TableHead>
        <TableBody>
          {license.map((lic) => (
            <TableRow key={lic.email}>
              <TableCell>{lic.progCode}</TableCell>
              <TableCell>{lic.name}</TableCell>
              <TableCell>{lic.tel}</TableCell>              
              <TableCell>{lic.compTel}</TableCell>      
              <TableCell>{lic.email}</TableCell>              
              <TableCell><Button onClick={ e => {changeButtonHandler(e,lic.email)}} variant="contained" color="primary">{MyMess.change}</Button></TableCell>
              {
              //<TableCell><Button onClick={ e => {historyButtonHandler(e,lic.email)}} variant="contained" color="primary">{MyMess.history}</Button></TableCell>  
              }
            </TableRow>
          ))}
        </TableBody>
      </Table>      
    </React.Fragment>
  )
}
